function NRExportIcon({ height = '24', width = '24', color = 'currentColor' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 16L14.58 14.58L16.17 12.99L8 12.99L8 11.01L16.17 11.01L14.58 9.42L16 8L20 12L16 16ZM17 20H6C4.9 20 4 19.1 4 18L4 6C4 4.89 4.9 4 6 4L17 4C18.11 4 19 4.89 19 6L19 7H17L17 6L6 6L6 18L17 18V17H19V18C19 19.1 18.11 20 17 20Z"
        fill={color}
      />
    </svg>
  );
}
export default NRExportIcon;
